import { toast } from "react-toastify";
import axiosHelper from "./axios-helper";

export const categoryEnum = (cb) => {
  console.log("categoryEnum çekiliyor...");
  axiosHelper
    .get("/category/get")
    .then((response) => {
      console.log("categoryEnum response:", response.data);
      if (response.data && cb) {
        cb(response.data);
      } else {
        console.warn("categoryEnum: Invalid response data");
        toast.error("Invalid response data");
      }
    })
    .catch((error) => {
      console.error("categoryEnum error:", error);
      axiosHelper.handleError(error, "Failed to fetch categories");
      if (cb) cb(null); // Callback'i null ile çağır
    });
};

export const getGameList = (c, cb) => {
  console.log("gameList çekiliyor, category:", c);
  if (!c) {
    console.warn("getGameList: Category parameter is required");
    toast.error("Category is required");
    if (cb) cb(null);
    return;
  }
  axiosHelper
    .get("/game/games?c=" + c)
    .then((response) => {
      console.log("gameList response:", response.data);
      if (response.data && cb) {
        cb(response.data);
      } else {
        console.warn("getGameList: Invalid response data");
        toast.error("Invalid response data");
      }
    })
    .catch((error) => {
      console.error("getGameList error:", error);
      axiosHelper.handleError(error, "Failed to fetch games");
      if (cb) cb(null); // Callback'i null ile çağır
    });
};

export const getEnumName = (list, id) => {
  return list?.find((a) => {
    return a._id === id;
  })?.name;
};
